import React, { useContext } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import AssuranceContext from "../../context/index";
import { Box, Grid, Typography } from "@material-ui/core";
import { useStyles } from "./dashboardStyles";
import CustomerDetailsField from "../proposal/partials/field";
import DownloadField from "../proposal/partials/download";
import {
  PLAN_NAME_ADLD,
  PLAN_NAME_OTSR,
  PLAN_NAME_EW,
  MOBILE_OTSR_PRODUCT_ID,
  MOBILE_ADLD_PRODUCT_ID,
  MOBILE_EW_PRODUCT_ID,
} from "../../constants";

function CustomerProfile({
  classes: { performanceCardsClaims, spacing },
  downloadFile,
}) {
  const {
    state: { userProfile: profile, productTndC },
    dispatch,
  } = useContext(AssuranceContext);
  return (
    <Grid item md={4}>
      <Box key={"customer-profile"} className={performanceCardsClaims}>
        <Box className={`${spacing}`}>
          <Typography variant={"subtitle2"}>Customer Profile</Typography>
        </Box>

        <Box className={spacing}>
          <CustomerDetailsField label={"Name"} value={profile.name ?? "-"} />
        </Box>
        <Box className={spacing}>
          <CustomerDetailsField
            label={"Mobile"}
            value={profile.mobile ?? "-"}
          />
        </Box>

        <Box className={spacing}>
          <CustomerDetailsField label={"Email"} value={profile.email ?? "-"} />
        </Box>

        <br />

        {(productTndC[MOBILE_OTSR_PRODUCT_ID] ||
          productTndC[MOBILE_ADLD_PRODUCT_ID] ||
          productTndC[MOBILE_EW_PRODUCT_ID]) && (
          <Box className={`${spacing}`}>
            <Typography variant={"subtitle2"}>
              Plan Terms &amp; Conditions
            </Typography>
          </Box>
        )}

        <Grid container spacing={3}>
          {productTndC[MOBILE_OTSR_PRODUCT_ID] && (
            <Grid item xs={12}>
              <DownloadField
                label={PLAN_NAME_OTSR}
                value="Download"
                isLink={true}
                url={profile.brochure.OTSR}
                onClick={downloadFile}
              />
            </Grid>
          )}
          {productTndC[MOBILE_ADLD_PRODUCT_ID] && (
            <Grid item xs={12}>
              <DownloadField
                label={PLAN_NAME_ADLD}
                value="Download"
                isLink={true}
                url={profile.brochure.ADLD}
                onClick={downloadFile}
              />
            </Grid>
          )}
          {productTndC[MOBILE_EW_PRODUCT_ID] && (
            <Grid item xs={12}>
              <DownloadField
                label={PLAN_NAME_EW}
                value="Download"
                isLink={true}
                url={profile.brochure.EW}
                onClick={downloadFile}
              />
            </Grid>
          )}
        </Grid>
      </Box>
    </Grid>
  );
}

export default withStyles(useStyles, { withTheme: true })(CustomerProfile);
